import { useState } from 'react';
import { useApolloClient } from '@apollo/client';
import RewardPointsAndBonusContainer from '../../container/rewardPointsAndBonusContainer';
import './style.scss';
import ViewRewardModal from '../../../RnRCommonComponent/ViewRewardModal/ViewRewardModal.jsx';
import RewardsProgressIndicator from 'src/_shared/components/rewards-progress-indicator/RewardsProgressIndicator.jsx';
import RecognitionReward from 'src/_shared/components/recognition-reward/RecognitionReward.jsx';
import RecentActivityCard from '../recentActivityCard/RecentActivityCard.jsx';
import MyBadgesList from '../../components/MyBadgesList/MyBadgesList.jsx';
import { getActivityDisplayMode, formatActivityTitle } from '../../utils/RecognitionModeUtils.js';

const MyrewardsPresentation = (props) => {
	const {
		handleOpenViewReward,
		handleCloseViewReward,
		isViewRewardModalVisible,
		rewardDetails,
		isModalLoaderVisible,
		tiers,
		currentUser,
		testRecognition,
		disableSpotlight,
		recentActivities = [],
		badgeAssignments = [],
		onClaimGift,
		onViewRecognition,
		onViewBadgeDetails,
		onMarkAsSeen,
		onClearTestRecognition,
	} = props;
	const [shouldRefresh, setShouldRefresh] = useState(false);
	const apolloClient = useApolloClient();
	const isSharingVisible = !currentUser?.company?.recognitionSettings?.hideRecognitionSocialShare;
	
	const displayMode = getActivityDisplayMode(currentUser?.company);
	const activityTitle = formatActivityTitle(displayMode);
	const isRecognitionMode = displayMode === 'recent_activity';

	return (
		<div className="my-recognitions">
			<div className="my-recognitions-container">
				<div className="row">
					<div className="col-xl-6 col-12">
						<RewardPointsAndBonusContainer />
					</div>
					<div className="col-xl-6 col-12">
						<div className="rewards-points d-card height-equal">
							<div className="d-card-head">
								<h4 className="d-title-no-case">{activityTitle}</h4>
							</div>
							{isRecognitionMode ? (
								<RecentActivityCard
									recentActivities={recentActivities}
									onClaimGift={onClaimGift}
									onViewRecognition={onViewRecognition}
									onMarkAsSeen={onMarkAsSeen}
									disableSpotlight={disableSpotlight}
								/>
							) : (
								<RewardsProgressIndicator
									currentUser={currentUser}
									tiers={tiers}
								/>
							)}
						</div>
					</div>
				</div>
			</div>
			
			{testRecognition && (
				<div className="test-recognition-container">
					<RecognitionReward
						recognition={testRecognition}
						currentUser={currentUser}
						disableSpotlight={disableSpotlight}
						onStateChange={(newState, id) => {
							console.log(`Recognition ${id} state changed to ${newState}`);
							if (newState === 'viewed' && onClearTestRecognition) {
								onClearTestRecognition();
							}
						}}
						onClaimGift={onClaimGift}
					/>
				</div>
			)}
			
			<MyBadgesList
				handleIconClickEvent={(badge) => {
					onViewBadgeDetails(badge);
				}}
				title="My Recognitions"
				shouldRefresh={shouldRefresh}
				setShouldRefresh={setShouldRefresh}
				isDetailsShown={false}
				isPointsShown={true}
				isIssuedVisible={true}
				currentUser={currentUser}
				client={apolloClient}
			/>
			<ViewRewardModal
				isViewRewardModalVisible={isViewRewardModalVisible}
				handleCloseViewReward={handleCloseViewReward}
				rewardDetails={rewardDetails}
				isModalLoaderVisible={isModalLoaderVisible}
				isSharingVisible={isSharingVisible}
			/>
		</div>
	);
};

export default MyrewardsPresentation;
